// extracted by mini-css-extract-plugin
module.exports = {"slider-track":"style_slider-track__EIp3x"};